import ko from 'knockout';
import logger from '@/Utils/logger';
import constants from '@/constants';
import FlowWrapper from '@/Utils/flowWrapper';
import { UploadType } from '@/Types/Enums/uploadType';

function UploadManager() {

  const self = this;

  // Observables to hold all the file uploads and the overall upload progress across all files
  // Important: do not use with ko rateLimit (see below).
  // self.uploads = ko.observableArray([]).extend({ rateLimit: 500 });
  // RateLimit breaks invoking of fileupload.send methods
  // Bug 188233: [Business Portal] Uploading of additional files causes error after starting upload of bunch of files
  self.uploads = ko.observableArray([]);
  self.uploadsCount = ko.observable(0);

  self.completedUploadsCount = ko.observable(0);
  self.failedUploadsCount = ko.observable(0);

  self.allUploadsProgress = ko.observable(0);
  self.allUploadsComplete = ko.observable(false);
  self.uploadsFailed = ko.observable(false);

  self.addUpload = function (upload) {
    self.uploads.push(upload);
    self.uploadsCount(self.uploads().length);
    self.allUploadsComplete(false);
  };

  self.getUpload = uploadId => {

    let upload = null;

    ko.utils.arrayForEach(self.uploads(), currentUpload => {

      if (currentUpload.uploadId === uploadId) {
        upload = currentUpload;
      }
    });

    return upload;
  };

  self.getUploadToken = function (file) {
    const upload = getUpload(file);
    return upload.uploadToken;
  };

  self.setUploadStarted = eventData => {
    const upload = self.getUpload(eventData.id);

    // If an upload file was already removed
    // don't do anything.
    if (!upload) {
      return;
    }

    upload.setUploadStarted();
  };

  self.setAllUploadsProgress = allUploadsProgress => {
    self.allUploadsProgress(allUploadsProgress);
  };

  self.updateUploadProgress = (uploadId, progress) => {

    const upload = self.getUpload(uploadId);

    // If a file was removed but a chunk finished uploading after the Ajax request was cancelled then
    // don't do anything.
    if (!upload) {
      return;
    }

    upload.updateUploadProgress(progress);
  };

  self.setUploadComplete = eventData => {
    const upload = self.getUpload(eventData.id);
    upload.setUploadComplete();
    removeUpload(upload);
    self.completedUploadsCount(self.completedUploadsCount() + 1);
  };

  // TODO: Can the error be passed across here as well?
  self.setUploadFailed = eventData => {

    const upload = self.getUpload(eventData.id);

    // If an upload file was already removed
    // don't do anything.
    if (!upload) {
      return;
    }

    // If the upload was cancelled, then we know about this ajax failure and can ignore it. Only if the
    // upload wasn't cancelled display the upload failure message.
    if (upload.statusName() === constants.uploadStatuses.cancelled) {
      return;
    }

    upload.setUploadFailed();
    removeUpload(upload);

    const errorMessage = 'Filename: ' + upload.fileName;
    logger.errorWithoutTimeout('UploadFailure', errorMessage);
    self.failedUploadsCount(self.failedUploadsCount() + 1);

    self.uploadsFailed(true);
  };

  /**
   * Cancels a file that is currently being uploaded or is pending upload
   * @param {*} upload FileUpload object
   */
  self.cancelUpload = function (upload) {
    if (upload.nativeBrowserFile) {
      FlowWrapper.cancelFileUpload(upload.nativeBrowserFile);
    }
    upload.cancelUpload();
    removeUpload(upload);
  };

  function getUpload(file) {

    let upload = null;

    ko.utils.arrayForEach(self.uploads(), function (currentUpload) {

      if (currentUpload.nativeBrowserFile === file) {
        upload = currentUpload;
      }
    });

    return upload;
  }

  function removeUpload(fileUpload) {

    self.uploads.remove(fileUpload);
    self.uploadsCount(self.uploads().length);

    if (self.uploadsCount() === 0) {
      self.allUploadsProgress(0);
      self.allUploadsComplete(true);
    }
  }

  self.isUploadArchive = uploadType => {
    return uploadType === UploadType.cctv ||
      uploadType === UploadType.cctvFile ||
      uploadType === UploadType.deviceBackup ||
      uploadType === UploadType.deviceBackupFile ||
      uploadType === UploadType.zipCctv ||
      uploadType === UploadType.zipDeviceBackup ||
      uploadType === UploadType.zipGeneralContent;
  };
}

export default new UploadManager();
